import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPasswordEmail } from '../../../services/userService';
import { logo } from '../../imagepath';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); 

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; 
    setIsSubmitting(true);
    setError(null);
    setMessage('');

    try {
      const response = await forgotPasswordEmail(email);
      setMessage(response.message || 'E-posta gönderildi.');
    } catch (error) {
      setError(error.response?.data?.message || 'Şifre sıfırlama e-postası gönderilirken bir hata oluştu.');
    } finally {
      setIsSubmitting(false); 
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="flex-grow-1">
        <div className="container-fluid">
          <div className="row min-vh-100 justify-content-center align-items-center">
            <div className="col-12 col-sm-8 col-md-6 col-lg-4 mt-5">
              {/* Logo kutusu */}
              <div className="bg-light rounded-4 shadow-sm p-3 mb-4 d-flex justify-content-center">
                <Link to="/home">
                  <img src={logo} className="img-fluid" alt="Logo" style={{ maxHeight: 50 }} />
                </Link>
              </div>
              {/* Form kutusu */}
              <div className="bg-light rounded-4 shadow-sm p-4">
                <h4 className="fw-semibold mb-2 text-center text-darkfume">Şifremi Unuttum?</h4>
                <hr className="mb-4 mt-0" />
                <div className="reset-password mb-3">
                  <p>Şifrenizi sıfırlamak için e-posta adresinizi girin.</p>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="input-block">
                    <label className="form-control-label text-darkfume text-sm">E-posta</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="E-posta adresinizi girin"
                      value={email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {error && <p style={{ color: 'red' }}>{error}</p>}
                  {message && <p style={{ color: 'green' }}>{message}</p>}
                  <div className="d-grid">
                    <button
                      className="btn btn-primary text-sm"
                      type="submit"
                      disabled={isSubmitting} // ✅ Spam engelleme
                    >
                      {isSubmitting ? 'Gönderiliyor...' : 'Gönder'}
                    </button>
                  </div>
                </form>
                <div className="text-sm mt-4">
                  <p className="mb-0 justify-content-center d-flex">
                    <Link className="text-blue me-4" to="/login">Giriş Yap</Link>
                    <Link className="text-blue" to="/register">Kayıt Ol</Link>
                  </p>
                </div>
              </div>
            </div>
            <footer className="w-100 text-center mt-auto mb-2">
              <small className="text-secondary">
                © 2025 Ideal Online &middot;
                <Link to="/support" className="text-secondary text-decoration-none mx-1">Destek</Link> &middot;
                <Link to="/kvkk" className="text-secondary text-decoration-none mx-1">KVKK</Link> &middot;
                <Link to="/help" className="text-secondary text-decoration-none mx-1">Yardım</Link>
              </small>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
